import { render, staticRenderFns } from "./CodeMgn.vue?vue&type=template&id=4459b86d"
import script from "./CodeMgn.vue?vue&type=script&lang=js"
export * from "./CodeMgn.vue?vue&type=script&lang=js"
import style0 from "./CodeMgn.vue?vue&type=style&index=0&id=4459b86d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports